(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bkfk-black-friday"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bkfk-sale-banner')) {
    customElements.define('bkfk-sale-banner', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.deadline);
        this.tick = () => {
          if (!Number.isFinite(this.end)) return;
          const seconds = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
          for (const [unit, value] of Object.entries(values)) {
            this.querySelectorAll('[data-unit="' + unit + '"]').forEach(node => { node.textContent = String(value).padStart(2, '0'); });
          }
          if (seconds === 0) clearInterval(this.timer);
        };
        this.tick();
        if (this.end > Date.now()) this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bkfk-coming-soon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bkfk-sale-banner')) {
    customElements.define('bkfk-sale-banner', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.deadline);
        this.tick = () => {
          if (!Number.isFinite(this.end)) return;
          const seconds = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
          for (const [unit, value] of Object.entries(values)) {
            this.querySelectorAll('[data-unit="' + unit + '"]').forEach(node => { node.textContent = String(value).padStart(2, '0'); });
          }
          if (seconds === 0) clearInterval(this.timer);
        };
        this.tick();
        if (this.end > Date.now()) this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
